var Ve = Object.defineProperty;
var et = (e, t, r) => t in e ? Ve(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var M = (e, t, r) => (et(e, typeof t != "symbol" ? t + "" : t, r), r);
import ce from "react";
import ae from "react/jsx-dev-runtime";
import le from "react/jsx-runtime";
import * as F from "@tanstack/react-query";
var g = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function de(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tt = 1 / 0,rt = "[object Symbol]",nt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,st = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,O = "\\ud800-\\udfff",fe = "\\u0300-\\u036f\\ufe20-\\ufe23",he = "\\u20d0-\\u20f0",pe = "\\u2700-\\u27bf",me = "a-z\\xdf-\\xf6\\xf8-\\xff",ot = "\\xac\\xb1\\xd7\\xf7",it = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",ut = "\\u2000-\\u206f",ct = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",xe = "A-Z\\xc0-\\xd6\\xd8-\\xde",ye = "\\ufe0e\\ufe0f",be = ot + it + ut + ct,I = "['’]",at = "[" + O + "]",G = "[" + be + "]",_ = "[" + fe + he + "]",ge = "\\d+",lt = "[" + pe + "]",ve = "[" + me + "]",we = "[^" + O + be + ge + pe + me + xe + "]",B = "\\ud83c[\\udffb-\\udfff]",dt = "(?:" + _ + "|" + B + ")",Ee = "[^" + O + "]",N = "(?:\\ud83c[\\udde6-\\uddff]){2}",z = "[\\ud800-\\udbff][\\udc00-\\udfff]",C = "[" + xe + "]",$e = "\\u200d",H = "(?:" + ve + "|" + we + ")",ft = "(?:" + C + "|" + we + ")",Z = "(?:" + I + "(?:d|ll|m|re|s|t|ve))?",Y = "(?:" + I + "(?:D|LL|M|RE|S|T|VE))?",Ce = dt + "?",Se = "[" + ye + "]?",ht = "(?:" + $e + "(?:" + [Ee, N, z].join("|") + ")" + Se + Ce + ")*",je = Se + Ce + ht,pt = "(?:" + [lt, N, z].join("|") + ")" + je,mt = "(?:" + [Ee + _ + "?", _, N, z, at].join("|") + ")",xt = RegExp(I, "g"),yt = RegExp(_, "g"),bt = RegExp(B + "(?=" + B + ")|" + mt + je, "g"),gt = RegExp([
  C + "?" + ve + "+" + Z + "(?=" + [G, C, "$"].join("|") + ")",
  ft + "+" + Y + "(?=" + [G, C + H, "$"].join("|") + ")",
  C + "?" + H + "+" + Z,
  C + "+" + Y,
  ge,
  pt].
  join("|"), "g"),vt = RegExp("[" + $e + O + fe + he + ye + "]"),wt = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Et = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "ss"
  },$t = typeof g == "object" && g && g.Object === Object && g,Ct = typeof self == "object" && self && self.Object === Object && self,St = $t || Ct || Function("return this")();
function jt(e, t, r, s) {
  var n = -1,o = e ? e.length : 0;
  for (s && o && (r = e[++n]); ++n < o;)
  r = t(r, e[n], n, e);
  return r;
}
function Tt(e) {
  return e.split("");
}
function Ft(e) {
  return e.match(nt) || [];
}
function _t(e) {
  return function (t) {
    return e == null ? void 0 : e[t];
  };
}
var Ot = _t(Et);
function Te(e) {
  return vt.test(e);
}
function Rt(e) {
  return wt.test(e);
}
function At(e) {
  return Te(e) ? Ut(e) : Tt(e);
}
function Ut(e) {
  return e.match(bt) || [];
}
function Lt(e) {
  return e.match(gt) || [];
}
var Mt = Object.prototype,Dt = Mt.toString,Q = St.Symbol,K = Q ? Q.prototype : void 0,X = K ? K.toString : void 0;
function Bt(e, t, r) {
  var s = -1,n = e.length;
  t < 0 && (t = -t > n ? 0 : n + t), r = r > n ? n : r, r < 0 && (r += n), n = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var o = Array(n); ++s < n;)
  o[s] = e[s + t];
  return o;
}
function kt(e) {
  if (typeof e == "string")
  return e;
  if (Wt(e))
  return X ? X.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -tt ? "-0" : t;
}
function Pt(e, t, r) {
  var s = e.length;
  return r = r === void 0 ? s : r, !t && r >= s ? e : Bt(e, t, r);
}
function It(e) {
  return function (t) {
    t = R(t);
    var r = Te(t) ? At(t) : void 0,s = r ? r[0] : t.charAt(0),n = r ? Pt(r, 1).join("") : t.slice(1);
    return s[e]() + n;
  };
}
function Nt(e) {
  return function (t) {
    return jt(Zt(Gt(t).replace(xt, "")), e, "");
  };
}
function zt(e) {
  return !!e && typeof e == "object";
}
function Wt(e) {
  return typeof e == "symbol" || zt(e) && Dt.call(e) == rt;
}
function R(e) {
  return e == null ? "" : kt(e);
}
var qt = Nt(function (e, t, r) {
  return t = t.toLowerCase(), e + (r ? Jt(t) : t);
});
function Jt(e) {
  return Ht(R(e).toLowerCase());
}
function Gt(e) {
  return e = R(e), e && e.replace(st, Ot).replace(yt, "");
}
var Ht = It("toUpperCase");
function Zt(e, t, r) {
  return e = R(e), t = r ? void 0 : t, t === void 0 ? Rt(e) ? Lt(e) : Ft(e) : e.match(t) || [];
}
var Yt = qt;
const Fe = /* @__PURE__ */de(Yt);
var Qt = 1 / 0,Kt = "[object Symbol]",W = "\\ud800-\\udfff",_e = "\\u0300-\\u036f\\ufe20-\\ufe23",Oe = "\\u20d0-\\u20f0",Re = "\\ufe0e\\ufe0f",Xt = "[" + W + "]",k = "[" + _e + Oe + "]",P = "\\ud83c[\\udffb-\\udfff]",Vt = "(?:" + k + "|" + P + ")",Ae = "[^" + W + "]",Ue = "(?:\\ud83c[\\udde6-\\uddff]){2}",Le = "[\\ud800-\\udbff][\\udc00-\\udfff]",Me = "\\u200d",De = Vt + "?",Be = "[" + Re + "]?",er = "(?:" + Me + "(?:" + [Ae, Ue, Le].join("|") + ")" + Be + De + ")*",tr = Be + De + er,rr = "(?:" + [Ae + k + "?", k, Ue, Le, Xt].join("|") + ")",nr = RegExp(P + "(?=" + P + ")|" + rr + tr, "g"),sr = RegExp("[" + Me + W + _e + Oe + Re + "]"),or = typeof g == "object" && g && g.Object === Object && g,ir = typeof self == "object" && self && self.Object === Object && self,ur = or || ir || Function("return this")();
function cr(e) {
  return e.split("");
}
function ke(e) {
  return sr.test(e);
}
function ar(e) {
  return ke(e) ? lr(e) : cr(e);
}
function lr(e) {
  return e.match(nr) || [];
}
var dr = Object.prototype,fr = dr.toString,V = ur.Symbol,ee = V ? V.prototype : void 0,te = ee ? ee.toString : void 0;
function hr(e, t, r) {
  var s = -1,n = e.length;
  t < 0 && (t = -t > n ? 0 : n + t), r = r > n ? n : r, r < 0 && (r += n), n = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var o = Array(n); ++s < n;)
  o[s] = e[s + t];
  return o;
}
function pr(e) {
  if (typeof e == "string")
  return e;
  if (br(e))
  return te ? te.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Qt ? "-0" : t;
}
function mr(e, t, r) {
  var s = e.length;
  return r = r === void 0 ? s : r, !t && r >= s ? e : hr(e, t, r);
}
function xr(e) {
  return function (t) {
    t = gr(t);
    var r = ke(t) ? ar(t) : void 0,s = r ? r[0] : t.charAt(0),n = r ? mr(r, 1).join("") : t.slice(1);
    return s[e]() + n;
  };
}
function yr(e) {
  return !!e && typeof e == "object";
}
function br(e) {
  return typeof e == "symbol" || yr(e) && fr.call(e) == Kt;
}
function gr(e) {
  return e == null ? "" : pr(e);
}
var vr = xr("toUpperCase"),wr = vr;
const Pe = /* @__PURE__ */de(wr);
(function (e) {
  typeof globalThis != "object" && (this ? t() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: t
  }), _T_));
  function t() {
    var r = this || self;
    r.globalThis = r, delete e.prototype._T_;
  }
})(Object);
class Ie {
  /**
   * Backoff that returns a constant interval.
   */
  constructor(t) {
    this.interval = t;
  }
  /**
   * @inheritdoc
   */
  next() {
    return Er(this.interval);
  }
}
const Er = (e) => ({
    duration: e,
    next() {
      return this;
    }
  }),$r = 4,Cr = 1 / 1.4,Sr = (e, t) => {
    const [r, s] = e || [0, 0],n = r + Math.random(),o = Math.pow(t.exponent, n) * Math.tanh(Math.sqrt($r * n)),u = isFinite(o) ? Math.max(0, o - s) : 1 / 0;
    return [
    Math.min(u * Cr * t.initialDelay, t.maxDelay),
    [r + 1, o]];

  },re = {
    generator: Sr,
    maxDelay: 3e4,
    exponent: 2,
    initialDelay: 128
  };
class jr {
  /**
   * An implementation of exponential backoff.
   */
  constructor(t) {
    this.options = t ? { ...re, ...t } : re;
  }
  next() {
    return Ne(this.options).next(void 0);
  }
}
const Ne = (e, t, r = 0, s = -1) => ({
  duration: r,
  next() {
    const [n, o] = e.generator(t, e);
    return Ne(e, o, n, s + 1);
  }
});
class ne extends Error {
  /**
   * Error thrown when a task is cancelled.
   */
  constructor(t = "Operation cancelled") {
    super(t), this.message = t, this.isTaskCancelledError = !0;
  }
}
const ze = { dispose: () => {
  } };
var se;
(function (e) {
  e.once = (t, r) => {
    let s = !1,n;
    return n = t((o) => {
      r(o), n ? n.dispose() : s = !0;
    }), s ? (n.dispose(), ze) : n;
  }, e.toPromise = (t, r) => {
    if (!r)
    return new Promise((n) => e.once(t, n));
    if (r.aborted)
    return Promise.reject(new ne());
    const s = [];
    return new Promise((n, o) => {
      const u = Tr(r);
      s.push(u), s.push(u.event(() => {
        o(new ne());
      })), s.push(e.once(t, (a) => {
        n(a);
      }));
    }).finally(() => {
      for (const n of s)
      n.dispose();
    });
  };
})(se || (se = {}));
const Tr = (e) => {
  const t = new Fr();
  if (e.aborted)
  return t.emit(), { event: t.addListener, dispose: () => {
    } };
  const r = () => e.removeEventListener("abort", s),s = () => {
      t.emit(), r();
    };
  return e.addEventListener("abort", s), { event: t.addListener, dispose: r };
};
class T {
  constructor() {
    this.addListener = (t) => this.addListenerInner(t);
  }
  /**
   * Gets the number of event listeners.
   */
  get size() {
    return this.listeners ? typeof this.listeners == "function" ? 1 : this.listeners.length : 0;
  }
  /**
   * Emits event data.
   */
  emit(t) {
    if (this.listeners)
    if (typeof this.listeners == "function")
    this.listeners(t);else

    for (const r of this.listeners)
    r(t);
  }
  addListenerInner(t) {
    return this.listeners ? typeof this.listeners == "function" ? this.listeners = [this.listeners, t] : this.listeners.push(t) : this.listeners = t, { dispose: () => this.removeListener(t) };
  }
  removeListener(t) {
    if (!this.listeners)
    return;
    if (typeof this.listeners == "function") {
      this.listeners === t && (this.listeners = void 0);
      return;
    }
    const r = this.listeners.indexOf(t);
    r !== -1 && (this.listeners.length === 2 ? this.listeners = r === 0 ? this.listeners[1] : this.listeners[0] : this.listeners = this.listeners.slice(0, r).concat(this.listeners.slice(r + 1)));
  }
}
class Fr extends T {
  constructor() {
    super(...arguments), this.addListener = (t) => this.lastValue ? (t(this.lastValue.value), ze) : this.addListenerInner(t);
  }
  /**
   * @inheritdoc
   */
  emit(t) {
    this.lastValue = { value: t }, super.emit(t), this.listeners = void 0;
  }
}
const We = new AbortController().signal,qe = new AbortController();
qe.abort();
qe.signal;
const _r = (e) => {
    if ("error" in e)
    throw e.error;
    return "success" in e ? e.success : e.value;
  },Or = () => {
    if (typeof performance < "u") {
      const e = performance.now();
      return () => performance.now() - e;
    } else {
      const e = process.hrtime.bigint();
      return () => Number(process.hrtime.bigint() - e) / 1e6;
    }
  };
class A {
  constructor(t = () => !1, r = () => !1) {
    this.errorFilter = t, this.resultFilter = r, this.successEmitter = new T(), this.failureEmitter = new T(), this.onSuccess = this.successEmitter.addListener, this.onFailure = this.failureEmitter.addListener;
  }
  clone() {
    return new A(this.errorFilter, this.resultFilter);
  }
  async invoke(t, ...r) {
    const s = this.successEmitter.size || this.failureEmitter.size ? Or() : null;
    try {
      const n = await t(...r);
      return this.resultFilter(n) ? (s && this.failureEmitter.emit({ duration: s(), handled: !0, reason: { value: n } }), { value: n }) : (s && this.successEmitter.emit({ duration: s() }), { success: n });
    } catch (n) {
      const o = n,u = this.errorFilter(o);
      if (s && this.failureEmitter.emit({ duration: s(), handled: u, reason: { error: o } }), !u)
      throw o;
      return { error: o };
    }
  }
}
class Rr {
  constructor() {
    this.executor = new A(), this.onSuccess = this.executor.onSuccess, this.onFailure = this.executor.onFailure;
  }
  async execute(t, r = We) {
    return _r(await this.executor.invoke(t, { signal: r }));
  }
}
const Ar = (e, t) => new Promise((r) => {
  const s = setTimeout(r, e);
  t && s.unref();
});
class q {
  constructor(t, r) {
    this.options = t, this.executor = r, this.onGiveUpEmitter = new T(), this.onRetryEmitter = new T(), this.onSuccess = this.executor.onSuccess, this.onFailure = this.executor.onFailure, this.onRetry = this.onRetryEmitter.addListener, this.onGiveUp = this.onGiveUpEmitter.addListener;
  }
  /**
   * When retrying, a referenced timer is created. This means the Node.js event
   * loop is kept active while we're delaying a retried call. Calling this
   * method on the retry builder will unreference the timer, allowing the
   * process to exit even if a retry might still be pending.
   */
  dangerouslyUnref() {
    return new q({ ...this.options, unref: !0 }, this.executor.clone());
  }
  /**
   * Executes the given function with retries.
   * @param fn Function to run
   * @returns a Promise that resolves or rejects with the function results.
   */
  async execute(t, r = We) {
    const s = this.options.backoff || new Ie(0);
    let n;
    for (let o = 0;; o++) {
      const u = await this.executor.invoke(t, { attempt: o, signal: r });
      if ("success" in u)
      return u.success;
      if (!r.aborted && o < this.options.maxAttempts) {
        const a = { attempt: o + 1, signal: r, result: u };
        n = n ? n.next(a) : s.next(a);
        const l = n.duration,d = Ar(l, !!this.options.unref);
        this.onRetryEmitter.emit({ ...u, delay: l, attempt: o + 1 }), await d;
        continue;
      }
      if (this.onGiveUpEmitter.emit(u), "error" in u)
      throw u.error;
      return u.value;
    }
  }
}
const oe = (e, t) => t ? (r) => r instanceof e && t(r) : (r) => r instanceof e,Ur = () => !0,Lr = () => !1;
class S {
  /**
   * Factory that builds a base set of filters that can be used in circuit
   * breakers, retries, etc.
   */
  constructor(t) {
    this.options = t;
  }
  /**
   * Allows the policy to additionally handles errors of the given type.
   *
   * @param cls Class constructor to check that the error is an instance of.
   * @param predicate If provided, a function to be called with the error
   * which should return "true" if we want to handle this error.
   * @example
   * ```js
   * // retry both network errors and response errors with a 503 status code
   * new Policy()
   *  .orType(NetworkError)
   *  .orType(ResponseError, err => err.statusCode === 503)
   *  .retry()
   *  .attempts(3)
   *  .execute(() => getJsonFrom('https://example.com'));
   * ```
   */
  orType(t, r) {
    const s = oe(t, r);
    return new S({
      ...this.options,
      errorFilter: (n) => this.options.errorFilter(n) || s(n)
    });
  }
  /**
   * Allows the policy to additionally handles errors that pass the given
   * predicate function.
   *
   * @param predicate Takes any thrown error, and returns true if it should
   * be retried by this policy.
   * @example
   * ```js
   * // only retry if the error has a "shouldBeRetried" property set
   * new Policy()
   *  .orWhen(err => err.shouldBeRetried === true)
   *  .retry()
   *  .attempts(3)
   *  .execute(() => getJsonFrom('https://example.com'));
   * ```
   */
  orWhen(t) {
    return new S({
      ...this.options,
      errorFilter: (r) => this.options.errorFilter(r) || t(r)
    });
  }
  /**
   * Adds handling for return values. The predicate will be called with
   * the return value of the executed function,
   *
   * @param predicate Takes the returned value, and returns true if it
   * should be retried by this policy.
   * @example
   * ```js
   * // retry when the response status code is a 5xx
   * new Policy()
   *  .orResultWhen(res => res.statusCode >= 500)
   *  .retry()
   *  .attempts(3)
   *  .execute(() => getJsonFrom('https://example.com'));
   * ```
   */
  orWhenResult(t) {
    return new S({
      ...this.options,
      resultFilter: (r) => this.options.resultFilter(r) || t(r)
    });
  }
  /**
   * Adds handling for return values. The predicate will be called with
   * the return value of the executed function,
   *
   * @param predicate Takes the returned value, and returns true if it
   * should be retried by this policy.
   * @example
   * ```js
   * // retry when the response status code is a 5xx
   * new Policy()
   *  .orResultType(res => res.statusCode >= 500)
   *  .retry()
   *  .attempts(3)
   *  .execute(() => getJsonFrom('https://example.com'));
   * ```
   */
  orResultType(t, r) {
    const s = oe(t, r);
    return new S({
      ...this.options,
      resultFilter: (n) => this.options.resultFilter(n) || s(n)
    });
  }
}
new Rr();
const Mr = new S({ errorFilter: Ur, resultFilter: Lr });
function Dr(e, t) {
  return new q({ backoff: t.backoff || new Ie(0), maxAttempts: t.maxAttempts ?? 1 / 0 }, new A(e.options.errorFilter, e.options.resultFilter));
}
const Br = "application/json",Je = "Content-Type",$ = Symbol(),Ge = Symbol();
function ie(e = {}) {
  var t;
  return (t = Object.entries(e).find(([r]) => r.toLowerCase() === Je.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function ue(e) {
  return /^application\/.*json.*/.test(e);
}
const w = function (e, t, r = !1) {
    return Object.entries(t).reduce((s, [n, o]) => {
      const u = e[n];
      return Array.isArray(u) && Array.isArray(o) ? s[n] = r ? [...u, ...o] : o : typeof u == "object" && typeof o == "object" ? s[n] = w(u, o, r) : s[n] = o, s;
    }, { ...e });
  },j = {
    // Default options
    options: {},
    // Error type
    errorType: "text",
    // Polyfills
    polyfills: {







      // fetch: null,
      // FormData: null,
      // URL: null,
      // URLSearchParams: null,
      // performance: null,
      // PerformanceObserver: null,
      // AbortController: null,
    }, polyfill(e, t = !0, r = !1, ...s) {const n = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);if (t && !n) throw new Error(e + " is not defined");return r && n ? new n(...s) : n;} };
function kr(e, t = !1) {
  j.options = t ? e : w(j.options, e);
}
function Pr(e, t = !1) {
  j.polyfills = t ? e : w(j.polyfills, e);
}
function Ir(e) {
  j.errorType = e;
}
const Nr = (e) => (t) => e.reduceRight((r, s) => s(r), t) || t;
class He extends Error {}

const zr = (e) => {
    const t = /* @__PURE__ */Object.create(null);
    e = e._addons.reduce((i, c) => c.beforeRequest && c.beforeRequest(i, e._options, t) || i, e);
    const { _url: r, _options: s, _config: n, _catchers: o, _resolvers: u, _middlewares: a, _addons: l } = e,d = new Map(o),m = w(n.options, s);
    let x = r;
    const p = Nr(a)((i, c) => (x = i, n.polyfill("fetch")(i, c)))(r, m),y = new Error(),b = p.catch((i) => {
        throw { [$]: i };
      }).then((i) => {
        if (!i.ok) {
          const c = new He();
          if (c.cause = y, c.stack = c.stack + `
CAUSE: ` + y.stack, c.response = i, c.url = x, i.type === "opaque")
          throw c;
          return i.text().then((f) => {
            var h;
            if (c.message = f, n.errorType === "json" || ((h = i.headers.get("Content-Type")) === null || h === void 0 ? void 0 : h.split(";")[0]) === "application/json")
            try {
              c.json = JSON.parse(f);
            } catch {
            }
            throw c.text = f, c.status = i.status, c;
          });
        }
        return i;
      }),U = (i) => i.catch((c) => {
        const f = c.hasOwnProperty($),h = f ? c[$] : c,L = (h == null ? void 0 : h.status) && d.get(h.status) || d.get(h == null ? void 0 : h.name) || f && d.has($) && d.get($);
        if (L)
        return L(h, e);
        const J = d.get(Ge);
        if (J)
        return J(h, e);
        throw h;
      }),E = (i) => (c) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */U(i ? b.then((f) => f && f[i]()).then((f) => c ? c(f) : f) : b.then((f) => c ? c(f) : f)),Ke = {
        _wretchReq: e,
        _fetchReq: p,
        _sharedState: t,
        res: E(null),
        json: E("json"),
        blob: E("blob"),
        formData: E("formData"),
        arrayBuffer: E("arrayBuffer"),
        text: E("text"),
        error(i, c) {
          return d.set(i, c), this;
        },
        badRequest(i) {
          return this.error(400, i);
        },
        unauthorized(i) {
          return this.error(401, i);
        },
        forbidden(i) {
          return this.error(403, i);
        },
        notFound(i) {
          return this.error(404, i);
        },
        timeout(i) {
          return this.error(408, i);
        },
        internalError(i) {
          return this.error(500, i);
        },
        fetchError(i) {
          return this.error($, i);
        }
      },Xe = l.reduce((i, c) => ({
        ...i,
        ...(typeof c.resolver == "function" ? c.resolver(i) : c.resolver)
      }), Ke);
    return u.reduce((i, c) => c(i, e), Xe);
  },Wr = {
    _url: "",
    _options: {},
    _config: j,
    _catchers: /* @__PURE__ */new Map(),
    _resolvers: [],
    _deferred: [],
    _middlewares: [],
    _addons: [],
    addon(e) {
      return { ...this, _addons: [...this._addons, e], ...e.wretch };
    },
    errorType(e) {
      return {
        ...this,
        _config: {
          ...this._config,
          errorType: e
        }
      };
    },
    polyfills(e, t = !1) {
      return {
        ...this,
        _config: {
          ...this._config,
          polyfills: t ? e : w(this._config.polyfills, e)
        }
      };
    },
    url(e, t = !1) {
      if (t)
      return { ...this, _url: e };
      const r = this._url.split("?");
      return {
        ...this,
        _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
      };
    },
    options(e, t = !1) {
      return { ...this, _options: t ? e : w(this._options, e) };
    },
    headers(e) {
      const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
      return { ...this, _options: w(this._options, { headers: t }) };
    },
    accept(e) {
      return this.headers({ Accept: e });
    },
    content(e) {
      return this.headers({ [Je]: e });
    },
    auth(e) {
      return this.headers({ Authorization: e });
    },
    catcher(e, t) {
      const r = new Map(this._catchers);
      return r.set(e, t), { ...this, _catchers: r };
    },
    catcherFallback(e) {
      return this.catcher(Ge, e);
    },
    resolve(e, t = !1) {
      return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
    },
    defer(e, t = !1) {
      return {
        ...this,
        _deferred: t ? [e] : [...this._deferred, e]
      };
    },
    middlewares(e, t = !1) {
      return {
        ...this,
        _middlewares: t ? e : [...this._middlewares, ...e]
      };
    },
    fetch(e = this._options.method, t = "", r = null) {
      let s = this.url(t).options({ method: e });
      const n = ie(s._options.headers),o = this._config.polyfill("FormData", !1),u = typeof r == "object" && !(o && r instanceof o) && (!s._options.headers || !n || ue(n));
      return s = r ? u ? s.json(r, n) : s.body(r) : s, zr(s._deferred.reduce((a, l) => l(a, a._url, a._options), s));
    },
    get(e = "") {
      return this.fetch("GET", e);
    },
    delete(e = "") {
      return this.fetch("DELETE", e);
    },
    put(e, t = "") {
      return this.fetch("PUT", t, e);
    },
    post(e, t = "") {
      return this.fetch("POST", t, e);
    },
    patch(e, t = "") {
      return this.fetch("PATCH", t, e);
    },
    head(e = "") {
      return this.fetch("HEAD", e);
    },
    opts(e = "") {
      return this.fetch("OPTIONS", e);
    },
    body(e) {
      return { ...this, _options: { ...this._options, body: e } };
    },
    json(e, t) {
      const r = ie(this._options.headers);
      return this.content(t || ue(r) && r || Br).body(JSON.stringify(e));
    }
  };
function v(e = "", t = {}) {
  return { ...Wr, _url: e, _options: t };
}
v.default = v;
v.options = kr;
v.errorType = Ir;
v.polyfills = Pr;
v.WretchError = He;
class qr extends Error {
  constructor(t) {
    super(`Dependency ${t} not found in provided dependency map.`), this.name = "DependencyMissingError";
  }
}
class Jr extends Error {
  constructor(t, r) {
    super(`Timeout while fetching umd bundle ${t}`), this.name = "FetchUmdBundleTimeoutError", this.cause = r;
  }
}
class Gr extends Error {
  constructor(t, r) {
    super(`Failed to fetch umd bundle ${t}`), this.name = "FetchUmdBundleError", this.cause = r;
  }
}
class Hr extends Error {
  constructor(t, r) {
    super(`Failed to evaluate umd bundle for ${t}`), this.name = "EvalUmdBundleError", this.cause = r;
  }
}
class Zr extends Error {
  constructor(t) {
    super(`Module for ${t} was undefined`), this.name = "ModuleUndefinedError";
  }
}
const D = /* @__PURE__ */new Map(),Yr = (e) => Ze({
    ...e,
    bundleLoader: Vr
  }),Qr = (e) => Ze({
    ...e,
    bundleLoader: tn
  }),Kr = async ({
    bundleLoader: e,
    bundleUrl: t,
    cxComponentName: r,
    dependenciesMap: s,
    retryPolicy: n = {
      maxRetries: 0
    }
  }, o) => {
    const u = Dr(Mr, {
      backoff: new jr(),
      maxAttempts: n.maxRetries
    });
    try {
      return await u.execute(
        () => e({
          bundleUrl: t,
          cxComponentName: r,
          dependenciesMap: s
        })
      );
    } catch (a) {
      throw o && o(), a;
    }
  },Xr = ({
    timestamp: e,
    ttlInMs: t
  }) => t == null || Date.now() - e < t,Ze = async ({
    baseCacheKey: e,
    cacheTtlInMs: t,
    ...r
  }) => {
    const { bundleUrl: s } = r,n = D.get(e);
    if (n && n.bundleUrl === s && Xr({
      timestamp: n.timestamp,
      ttlInMs: t
    }))
    return n.promise;
    const o = Kr(r, () => {
      D.delete(e);
    });
    return D.set(e, {
      bundleUrl: s,
      promise: o,
      timestamp: Date.now()
    }), o;
  },Vr = async ({
    bundleUrl: e,
    cxComponentName: t,
    dependenciesMap: r
  }) => {
    let s;
    try {
      s = await v(e).get().timeout((n) => {
        throw new Jr(e, n);
      }).text();
    } catch (n) {
      throw new Gr(e, n);
    }
    try {
      return en(t, s, r);
    } catch (n) {
      throw new Hr(t, n);
    }
  },en = (e, t, r) => {
    const s = globalThis.define;
    let n;
    globalThis.define = (o, u) => {
      n = u(
        ...o.map((a) => {
          const l = r[a];
          if (!l)
          throw new qr(a);
          return l;
        })
      );
    }, globalThis.define.amd = !0;
    try {
      new Function(t)();
    } finally {
      globalThis.define = s;
    }
    if (!n)
    throw new Zr(e);
    return n;
  },tn = async ({
    bundleUrl: e,
    cxComponentName: t,
    dependenciesMap: r
  }) => {
    const s = document.createElement("script");
    s.src = e;
    const n = new Promise((o, u) => {
      s.addEventListener("load", () => {
        o(
          window.cxComponentExports[t]
        );
      }), s.addEventListener("error", (a) => {
        document.head.contains(s) && document.head.removeChild(s), u(a.error);
      });
    });
    return window.cxComponentDeps = {
      ...window.cxComponentDeps,
      ...r
    }, document.head.appendChild(s), n;
  },rn = async (e, { contractVersion: t, name: r }, {
    dependenciesMap: s = {},
    insertCss: n = !0,
    loadingOptions: o = {}
  } = {}) => {
    const { cacheTtlInMs: u = 2 * 60 * 1e3, retryPolicy: a = { maxRetries: 3 } } = o,l = Pe(Fe(r)),d = `${e}/modules/${r}/${l}-${t}-umd.js`,m = `${e}/modules/${r}/${l}-${t}-style.css`,p = window[`cxComponent${l}Config`] ?? {
        cssBundle: m,
        dehydratedState: void 0,
        umdBundle: d
      },y = await Qr({
        baseCacheKey: `${l}-${t}-${e}`,
        bundleUrl: p.umdBundle,
        cacheTtlInMs: u,
        cxComponentName: l,
        dependenciesMap: s,
        retryPolicy: a
      });
    if (!n)
    return {
      Component: y,
      cssBundle: p.cssBundle,
      dehydratedState: p.dehydratedState
    };
    if (p.cssBundle && !nn(p.cssBundle)) {
      const b = document.createElement("link");
      b.rel = "stylesheet", b.href = m, document.head.appendChild(b);
    }
    return {
      Component: y,
      cssBundle: p.cssBundle,
      dehydratedState: p.dehydratedState
    };
  },nn = (e) => !!document.querySelector(`link[rel="stylesheet"][href="${e}"]`),sn = async (e, {
    contractVersion: t,
    dehydratedState: r,
    initialZustandState: s,
    name: n
  }, { dependenciesMap: o = {}, loadingOptions: u = {} } = {}) => {
    const { cacheTtlInMs: a = 2 * 60 * 1e3, retryPolicy: l = { maxRetries: 3 } } = u,d = Pe(Fe(n)),m = `${e}/modules/${n}/${d}-${t}-umd.js`,x = `${e}/modules/${n}/${d}-${t}-style.css`,p = await Yr({
        baseCacheKey: `${d}-${t}-${e}`,
        bundleUrl: m,
        cacheTtlInMs: a,
        cxComponentName: d,
        dependenciesMap: o,
        retryPolicy: l
      }),y = `window["cxComponent${d}Config"] = ${JSON.stringify(
        {
          cssBundle: x,
          dehydratedState: r,
          initialZustandState: s,
          umdBundle: m
        }
      )}`,b = `
${x ? `<link rel="stylesheet" href="${x}">` : ""}
<link rel="preload" href="${m}" as="script">
<script>${y}<\/script>`;
    return {
      Component: p,
      dehydratedState: r,
      initialZustandState: s,
      ssrConfig: {
        cssBundle: x,
        jsBundle: m,
        moduleConfigScript: y
      },
      stringToAddToSsrResult: b
    };
  };
function on(e = {}) {
  return new F.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(t) {
          return t * 100;
        }
      }
    },
    ...e
  });
}
class un extends Error {
  constructor(r, s) {
    super("Data not found for the given parameters.");
    M(this, "args");
    M(this, "endpoint");
    this.name = "DataNotFound", this.endpoint = r, this.args = s;
  }
}
class cn extends Error {
  constructor(t, r) {
    super(t), this.name = "UnknownError", this.cause = r;
  }
}
const an = async (e = "https://offers-delivery-api-stg.core.occloud.io", t) => {
    const { apiKey: r, countryCode: s, deviceTypeForApi: n, path: o, subdivisionCode: u } = t;
    if (!r || !o)
    return;
    const a = new URL(`${e}/v1/offers/pages/${o}`);
    return v(a.toString(), {
      headers: {
        accept: "application/json",
        "api-key": r,
        "content-type": "application/json",
        ...(s ? { "country-code": s } : {}),
        ...(n ? { "device-type": n } : {}),
        ...(u ? { "subdivision-code": u } : {})
      }
    }).get().notFound(() => {
      throw new un(a.pathname, t);
    }).json().catch((l) => {
      throw new cn("Error fetching offers data", l);
    });
  },ln = ({
    apiKey: e,
    countryCode: t,
    deviceTypeForApi: r,
    path: s,
    subdivisionCode: n
  }) =>
  // Because countryCode and subdivisionCode are optional, filter out undefined (falsy) values
  [
  "offers-list",
  e,
  s,
  t,
  n,
  r].
  filter(Boolean),
  dn = "@cx-modules/offers-list",Ye = "1.9.1",[, Qe] = dn.split("/"),xn = async (e, { dataApiEndpoint: t, ...r }, s, n) => {
    const o = on();
    await o.prefetchQuery(
      ln(r),
      () => an(t, r)
    ).catch((a) => {
      var l;
      (l = n == null ? void 0 : n.logger) == null || l.error(a);
    });
    const u = F.dehydrate(o);
    return await sn(
      e,
      {
        contractVersion: Ye,
        dehydratedState: u,
        name: Qe,
        ...(s && { meta: s })
      },
      {
        dependenciesMap: {
          "@tanstack/react-query": F,
          react: ce,
          "react/jsx-dev-runtime": ae,
          "react/jsx-runtime": le
        },
        ...n
      }
    );
  },yn = async (e, t, r) => await rn(
    e,
    {
      contractVersion: Ye,
      name: Qe,
      ...(t && { meta: t })
    },
    {
      dependenciesMap: {
        "@tanstack/react-query": F,
        react: ce,
        "react/jsx-dev-runtime": ae,
        "react/jsx-runtime": le
      },
      ...r
    }
  );
export {
  yn as loadClient,
  xn as loadServer };